import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api/instance';

export interface PaymentTextTranslation {
  id: string;
  lang: string;
  text_after_payment: string | null;
}

export interface PaymentTextListResponse {
  translations: PaymentTextTranslation[];
}

export type PaymentTextsUpdatePayload = Record<string, string | null>;

const companyPaymentTextPath = (companyId: string) => `/companies/${companyId}/payment-text`;

export const getPaymentTexts = async ({
  companyId,
}: {
  companyId: string;
}): Promise<AxiosResponse<PaymentTextListResponse>> => {
  return instance.get(companyPaymentTextPath(companyId)).catch(e => e.response as AxiosError<ApiError> as never);
};

export const savePaymentTexts = async ({
  companyId,
  data,
}: {
  companyId: string;
  data: PaymentTextsUpdatePayload;
}): Promise<AxiosResponse<PaymentTextListResponse>> => {
  return instance
    .post(companyPaymentTextPath(companyId), {
      translations: data,
    })
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deletePaymentText = async ({ companyId, lang }: { companyId: string; lang: string }) => {
  return instance
    .delete(companyPaymentTextPath(companyId), {
      params: { lang },
    })
    .catch(e => e.response as AxiosError<ApiError> as never);
};
